/**
 * Canonical seed list for the "Grape(s)" multi-select chip picker on
 * the Wine category template. Imported by every preset definition so
 * the picker stays consistent regardless of which entry point creates
 * the category (CategoryBuilder, Categories list presets, or the
 * Wine guided modal).
 *
 * Users can add custom grapes at the item-entry stage — those custom
 * values are stored on the item (in `item_data["Grape(s)"]`) but are
 * NOT added back into the category schema's options list. To extend
 * the seed picker across all categories, edit this array.
 */
export const GRAPE_VARIETIES = [
  "Cabernet Sauvignon",
  "Merlot",
  "Shiraz / Syrah",
  "Pinot Noir",
  "Grenache",
  "Sangiovese",
  "Tempranillo",
  "Malbec",
  "Nebbiolo",
  "Zinfandel",
  "Cabernet Franc",
  "Mourvèdre / Monastrell",
  "Gamay",
  "Chardonnay",
  "Sauvignon Blanc",
  "Riesling",
  "Pinot Gris / Pinot Grigio",
  "Chenin Blanc",
  "Gewürztraminer",
  "Viognier",
  "Semillon",
  "Albariño",
  "Grüner Veltliner",
  "Muscat / Moscato",
  "Pinot Meunier",
  "Carignan",
  "Cinsault",
  "Touriga Nacional",
  "Fiano",
];
